import type { FloorPlanTablesRenderer } from '@components/floorPlan/FloorPlan';
import { FloorPlan } from '@components/floorPlan/FloorPlan';
import type { HostFloorPlanTable } from 'restaurantAdmin/floorPlans/apiHelpers';
import { type TableTimerDictionary } from '../state/ReservationServiceContext';
import { OccupantFloorPlanTableFactory } from './OccupantFloorPlanTableFactory';

export interface OccupantFloorPlanProps {
  backgroundSrc?: string;
  className?: string;
  listingIdsToPulsate?: string[];
  tables: HostFloorPlanTable[];
  emptyTableOnClick: (floorPlanTable: HostFloorPlanTable) => void;
  tableTimersByFloorPlanTableId: TableTimerDictionary;
  selectedEmptyTableId?: string;
}

export const OccupantFloorPlan = ({
  backgroundSrc,
  className,
  tables,
  emptyTableOnClick,
  selectedEmptyTableId,
  tableTimersByFloorPlanTableId,
  listingIdsToPulsate,
}: OccupantFloorPlanProps) => {
  const floorPlanTablesRenderer: FloorPlanTablesRenderer = (tableIconScale) => (
    <>
      {tables.map((floorPlanTable) => (
        <OccupantFloorPlanTableFactory
          floorPlanTable={floorPlanTable}
          handleTableOnClick={emptyTableOnClick}
          key={floorPlanTable.id}
          listingIdsToPulsate={listingIdsToPulsate}
          selectedEmptyTableId={selectedEmptyTableId}
          timer={tableTimersByFloorPlanTableId[floorPlanTable.id] || null}
          tableIconScale={tableIconScale}
        />
      ))}
    </>
  );

  return (
    <FloorPlan
      backgroundSrc={backgroundSrc}
      className={className}
      floorPlanTablesRenderer={floorPlanTablesRenderer}
      scaleOnVerticalResize
    />
  );
};
